import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "toast-stack",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "toast-icon" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "toast-spinner"
}
const _hoisted_6 = { class: "toast-message" }
const _hoisted_7 = ["onClick"]

import { useToast } from "@/use/useToast";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastNotification',
  setup(__props) {

const { toasts, dismiss } = useToast();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(['toast', `toast--${toast.type}`])
            }, [
              _createElementVNode("span", _hoisted_2, [
                (toast.type === 'success')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "✓"))
                  : (toast.type === 'error')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "✕"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5))
              ]),
              _createElementVNode("span", _hoisted_6, _toDisplayString(toast.message), 1),
              _createElementVNode("button", {
                class: "toast-close",
                "aria-label": "Dismiss",
                onClick: ($event: any) => (_unref(dismiss)(toast.id))
              }, "✕", 8, _hoisted_7)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})